import React from "react";

function StatCard({ Title, value, subtext,role }) {
  return (
    <div className={`bg-white shadow-lg rounded-lg p-4 ${role=="System Admin"?"w-[250px]":"w-[215]"} h-[130px] flex flex-col justify-between`}>
     <center>
     <h3 className="text-gray-700 text-lg font-semibold mb-[15px]">{Title}</h3>
      <p className="text-2xl font-bold text-gray-900 mb-[5px]">{value}</p>
      <p className="text-sm text-gray-500">{subtext}</p>
       </center>
    </div>
  );
}

export default StatCard;
